// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4099":"d3755eaf","7075":"3b53517f","7339":"3b53517f","8176":"0577ec51"}[chunkId] + ".chunk.css";
};